import axios from 'axios';
export interface ReferralPerson {id: string; name: string; phone: string; email: string; role: string; code: string}
export interface ReferredPerson extends ReferralPerson {
  rewardAmount: number; rewardPerCustomer: number;
  referredAt: string; completedJobs: number; eligible: boolean;
  firstJob: {key: string; confirmedAt: string; reviewed: boolean; confirmed?: boolean} | null;
}
export interface ReferralRow {
  rewardPerCustomer: number; rewardRevision: number;
  deletedAt?: string | null;
  id: string; code: string; owner: ReferralPerson | null; notificationStatus: string; notificationError?: string;
  customersReferred: number; providersReferred: number; customersCompleted: number; providersCompleted: number;
  qualifyingCustomers: number; eligibleReward: number; referrals: ReferredPerson[];
}
export interface ReferralReport {rows: ReferralRow[]; total: number; page: number; pageSize: number}
export async function referralApi<T = any>(method: 'GET' | 'POST' | 'DELETE' | 'PATCH', path: string, data?: any, signal?: AbortSignal): Promise<T> {
  try {
    return (await axios.request<T>({method, url: `${process.env.REACT_APP_BASE_URL}/admin/referral-program${path}`,
      ...(method === 'GET' ? {params: data} : {data}), withCredentials: true, signal, timeout: 60000})).data;
  } catch (error: any) {
    if (axios.isCancel(error)) throw error;
    throw new Error(error.response?.data?.message || error.response?.data?.error?.message ||
      'Referral tracking is unavailable. Please retry; missing data has not been counted as zero.');
  }
}
